<template>
  <div class="loader__holder">
    <div class="lds-ring"><div /><div /><div /><div /></div>
    <div class="loader__title">
      <slot name="title">Loading...</slot>
    </div>
    <div class="loader__description">
      <slot name="description">
        {{ currentText }}
      </slot>
    </div>
    <p class="thank__you">
      Thank you for your patience
      as this could take up to a minute
    </p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      current: 0,
      currentText: 'Searching for lenders that meet your needs',
      text: [
        'Finding best deals and programs',
        'Applying discounts'
      ]
    }
  },
  watch: {
    'current' (newValue, oldValue) {
      if (this.current !== this.text.length) { setTimeout(this.changeText, 3000) }
    }
  },
  mounted () {
    setTimeout(this.changeText, 3000)
  },
  methods: {
    changeText () {
      this.currentText = this.text[this.current]
      this.current++
    }
  }
}
</script>
